<template>
	<div>
	<!-- begin page-header -->
		<h1 class="page-header">Trapezoidal <small>fuzzy membership function</small></h1>
		<!-- end page-header -->
		
				<!-- begin widget-chart -->
				<div class="widget widget-rounded m-b-30" v-bind:class="{ 'inverse-mode': inverseMode } " >
					<!-- begin widget-header -->
					<div class="widget-header">
						<h4 class="widget-header-title">Trapezoidal Fuzzy Membership Function</h4>
						<div class="widget-header-icon"><a href="javascript:;" class="text-muted"><i class="fa fa-fw fa-upload"></i></a></div>
						<div class="widget-header-icon"><a href="javascript:;" class="text-muted"><i class="fa fa-fw fa-cog"></i></a></div>
					</div>
					<!-- end widget-header -->
					<!-- begin vertical-box -->
					<div class="vertical-box with-grid with-border-top" >
						<!-- begin vertical-box-column -->
						<div class="vertical-box-column widget-chart-content">
							<div class="nv-stacked-area-chart height-full">
								<vn-stacked-area :model="stackedAreaChart.data"
									yFormat=",.2f" 
									:height="stackedAreaChart.height"
									xFormat=",.0f" 
									:clipEdge="stackedAreaChart.clipEdge"
									:rightAlignYAxis="stackedAreaChart.rightAlignYAxis" 
									:showControls="stackedAreaChart.showControls">
								</vn-stacked-area>
							</div>
						</div>
						<!-- end vertical-box-column -->
					
					</div>
					<!-- end vertical-box -->
				</div>
				<!-- end widget-chart -->
	</div>
</template>


<script>
export default {
  data() {
    var trapezoidMF = [];
    var a = 50;
    var b = 55;
    var c = 65;
    var d = 70;
    var mu = 0;
    for (var i = 0; i < 80; i++) {
      mu = 0;

      if (i <= a) {
        mu = 0;
      }
      if (a <= i && i <= b) {
        mu = (i - a) / (b - a);
      }
      if (b <= i && i <= c) {
        mu = 1;
      }
      if (c <= i && i <= d) {
        mu = (d - i) / (d - c);
      }
      if (d <= i) {
        mu = 0;
      }
      trapezoidMF.push({ x: i, y: mu });
    }

    var trapezoidMF2 = [];
    a = 0;
    b = 10;
    c = 15;
    d = 20;

    for (i = 0; i < 80; i++) {
      mu = 0;

      if (i <= a) {
        mu = 0;
      }
      if (a <= i && i <= b) {
        mu = (i - a) / (b - a);
      }
      if (b <= i && i <= c) {
        mu = 1;
      }
      if (c <= i && i <= d) {
        mu = (d - i) / (d - c);
      }
      if (d <= i) {
        mu = 0;
      }
      trapezoidMF2.push({ x: i, y: mu });
    }

    var trapezoidMF3 = [];
    a = 20;
    b = 35;
    c = 45;
    d = 50;
    for (i = 0; i < 80; i++) {
      mu = 0;

      if (i <= a) {
        mu = 0;
      }
      if (a <= i && i <= b) {
        mu = (i - a) / (b - a);
      }
      if (b <= i && i <= c) {
        mu = 1;
      }
      if (c <= i && i <= d) {
        mu = (d - i) / (d - c);
      }
      if (d <= i) {
        mu = 0;
      }
      trapezoidMF3.push({ x: i, y: mu });
    }

    var stackedAreaChartData = [
      {
        key: "Mladý",
        color: "#2d353c",
        values: trapezoidMF3
      },
      {
        key: "Dospelý",
        color: "#f59c1a",
        values: trapezoidMF2
      },
      {
        key: "Starý človek",
        color: "#ff5b57",
        values: trapezoidMF
      }
    ];

    return {
      inverseMode: false,
      stackedAreaChart: {
        data: stackedAreaChartData,
        rightAlignYAxis: false,
        showControls: false,
        clipEdge: true,
        height: "350px"
      }
    };
  },
  methods: {
    handleChangeWidgetTheme: function(theme) {
      if (theme == "light") {
        this.inverseMode = false;
      } else if (theme == "inverse") {
        this.inverseMode = true;
      }
    }
  }
};
</script>